module.exports = __webpack_public_path__ + "static/media/food1.9af6856b.JPG";